import type { BracketColor } from 'modules/tournaments/ui/components/form-parts/stages/stage-grid/stage-brackets/round-brackets/round-brackets';
import React, { useCallback } from 'react';
import classNames from 'classnames';
import { Team } from 'modules/teams/domain/interfaces/team';
import UDFormSelect from 'ud-form/components/select';
import { SelectOption, UDSelect, UDSelectProps } from 'ud-form/components/select/component';
import overrideSelectComponents from 'ud-form/components/select/component/override';
import { teamToTeamOption } from '../team-select-option';
import { StyledSelectControl, StyledSelectPlaceholder, StyledTeamCard } from './bracket-team-field.styles';

const CustomSelect = (props: UDSelectProps) => {
  const components = {
    ...overrideSelectComponents,
    Control: (props: any) => {
      return (
        <StyledSelectControl
          {...props.innerProps}
          className={classNames('flex flex-row', {
            disabled: props.isDisabled,
            focused: props.isFocused,
            multi: props.isMulti,
            opened: props.menuIsOpen,
          })}
        >
          {props.children}
        </StyledSelectControl>
      );
    },
  };

  return <UDSelect {...props} components={components} />;
};

type BracketTeamFieldProps = {
  index: number;
  roundId: number;
  bracketId: number;
  teams: Team[];
  selectedTeamId?: number | null;
  onBracketTeamChange: (index: number, teamId: number | null) => void;
  onlyShow?: boolean;
  color?: BracketColor;
};
export const BracketTeamField = ({
  index,
  roundId,
  bracketId,
  teams,
  selectedTeamId,
  onBracketTeamChange,
  onlyShow = false,
  color,
}: BracketTeamFieldProps) => {
  const teamsOptions = teams.map(teamToTeamOption);

  const selectedOption = selectedTeamId ? teamsOptions.find((option) => option.value === selectedTeamId) || null : null;

  const handleChange = useCallback(
    (value: SelectOption<number> | null) => {
      if (!onBracketTeamChange) {
        return;
      }

      const teamId = value ? value.value : null;
      onBracketTeamChange(index, teamId);
    },
    [index, onBracketTeamChange],
  );

  if (onlyShow) {
    const team = teams.find((team) => team.id === selectedTeamId);
    if (team) {
      return (
        <StyledTeamCard>
          <img
            src={team.logo?.url}
            alt="logo team"
            className="m-0! z-10 size-9 min-h-9 min-w-9 overflow-hidden rounded-lg object-contain"
          />
          <span className="w-full truncate">{team.name}</span>
        </StyledTeamCard>
      );
    }

    return (
      <StyledTeamCard>
        <span className={classNames('justify-center items-center z-10 flex size-9 text-2xl', color)}>⏳</span>
        <span>TBD</span>
      </StyledTeamCard>
    );
  }

  return (
    <UDFormSelect
      name={`rounds[${roundId}].brackets[${bracketId}][${index}]`}
      options={teamsOptions}
      value={selectedOption}
      placeholder={<StyledSelectPlaceholder>Выбрать команду</StyledSelectPlaceholder>}
      selectComponent={CustomSelect}
      onChange={handleChange}
    />
  );
};
